module.exports = __webpack_public_path__ + "static/media/searchBarIcon.a80f2d56.svg";